import { Component } from 'react';
import adsenseConfig from '../../config/adsense';

const SCRIPT_ID = 'adsense-script';

class AdSenseLoader extends Component {
    componentDidMount() {
        if (!adsenseConfig.enabled || typeof document === 'undefined') {
            return;
        }

        if (document.getElementById(SCRIPT_ID)) {
            return;
        }

        const script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.async = true;
        script.crossOrigin = 'anonymous';
        script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adsenseConfig.client}`;
        document.head.appendChild(script);
    }

    render() {
        return null;
    }
}

export default AdSenseLoader;



// WEBPACK FOOTER //
// ./src/component/adsense/adSenseLoader.js